import { lazy, Suspense, useEffect } from "react";
import { TrackingProvider } from "./analytics/TrackingProvider.tsx";
import {
  LoadingScreen,
  LoadingScreenProvider,
} from "./sections/LoadingScreen/index.ts";
import { GlobalStyles } from "./styles/index.ts";

const AppLazy = import("./AppLazy");
const LazyApp = lazy(() => AppLazy);

declare global {
  interface Window {
    __track: (event: string, properties?: Record<string, unknown>) => void;
  }
}

export const App = () => (
  <LoadingScreenProvider>
    <TrackingProvider
      track={(event, properties) => {
        if (window.__track) {
          window.__track(event, properties);
          document.dispatchEvent(
            new CustomEvent(`BINGO:${event}`, { detail: properties }),
          );
        }

        if (process.env.NODE_ENV === "development") {
          console.debug("track", event, properties);
        }
      }}
    >
      <Suspense fallback={<LoadingScreen />}>
        <GlobalStyles />
        <PreloadRouter />
        <LazyApp />
      </Suspense>
    </TrackingProvider>
  </LoadingScreenProvider>
);

const PreloadRouter = () => {
  useEffect(() => {
    import("./Router").catch((error) => console.error(error));
  }, []);
  return null;
};

export default App;
